"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorage {
    constructor(wpApiSettings, currentBlogId) {
        this.wpApiSettings = wpApiSettings;
        this.currentBlogId = currentBlogId;
        this.localeStorageKey = 'liked-posts-v2';
        this.likedPosts = this.sanitizeLikedPosts(JSON.parse(localStorage.getItem(this.localeStorageKey) || '{}'));
    }
    get() {
        return this.likedPosts;
    }
    set(postId, postType, blogId) {
        let likedPostsIds = this.get();
        const key = `${blogId}-${postId}`;
        if (likedPostsIds[key]) {
            delete likedPostsIds[key];
        }
        else {
            likedPostsIds[key] = {
                postType: postType,
                blogId: blogId,
                postId: postId,
                likedAt: Date.now(),
                website: this.wpApiSettings.root
            };
        }
        localStorage.setItem(this.localeStorageKey, JSON.stringify(likedPostsIds));
        this.likedPosts = likedPostsIds;
    }
    // Sanitizes how old liked posts are stored in local storage.
    // This is for backwards compatibility with older versions of the plugin.
    sanitizeLikedPosts(likedPosts) {
        const localLikedPosts = {};
        for (const id in likedPosts) {
            if (typeof likedPosts[id] !== 'string') {
                localLikedPosts[id] = likedPosts[id];
                continue;
            }
            const key = `${this.currentBlogId}-${id}`;
            localLikedPosts[key] = {
                postType: likedPosts[id],
                blogId: this.currentBlogId,
                postId: id,
                likedAt: Date.now(),
                website: this.wpApiSettings.root
            };
        }
        return localLikedPosts;
    }
}
exports.default = LocalStorage;
